import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';

const ModalImageZoom = (item) => {
    const VISIBLE = item.dadComponent.state.modalZoom; 
    const TOGGLE_MODAL = item.dadComponent['toggleModalZoom'];
    const IMAGE = item.dadComponent.state.imgZoom;

    return (
        <div>
            <Modal isOpen={VISIBLE} toggle={TOGGLE_MODAL} className='modal_zoom' centered backdrop="static">
                <button className="btn-icon modal-close" onClick={TOGGLE_MODAL}><SvgAssets icon="icon-close" fill={c.celeste} /></button>
                <InnerImageZoom src={IMAGE} zoomSrc={IMAGE}/>
            </Modal>
        </div>
    )
}

export default ModalImageZoom;